import {CounterItemConfig} from 'filters/features/FilterTopbar/types';
import {assertPageFilter} from 'filters/types';

import {useSourceFilter, useFilterLoading} from 'filters/contexts/FilterStackProvider';
import {useFilterActionsContext} from 'filters/contexts/FilterActionsProvider/FilterActionsProvider';

import {BaseFilterTopBarItem} from 'modules/decisionsNext/components/BaseFilter/TopBar/BaseFilterTopBarItem';

export const createCounterItem = <V,>(config: Omit<CounterItemConfig<V>, 'type'>): CounterItemConfig<V> => {
  return {
    ...config,
    type: 'counter',
  };
};

export const CounterItem = ({
  disabled,
  variant,
  entity,
  getCount,
  getTooltip,
  onClick,
  onReset,
}: CounterItemConfig<any>) => {
  const filter = useSourceFilter();
  const loading = useFilterLoading();
  const {useApplyFilter} = useFilterActionsContext();
  const onApply = useApplyFilter();
  const count = getCount(filter);

  if (!count) {
    return null;
  }

  return (
    <BaseFilterTopBarItem
      disabled={disabled}
      loading={loading}
      variant={variant}
      label={
        <>
          {entity} <b>{count}</b>
        </>
      }
      tooltip={getTooltip?.(filter, count)}
      onClick={onClick}
      onDelete={
        onReset
          ? () => {
              assertPageFilter(filter);

              onApply(onReset(filter));
            }
          : undefined
      }
    />
  );
};
